import React, { useEffect, useState } from "react";
import dataProvider from "server/dataProvider";
import { DISCIPLINES, RECORDS, STUDENT_EDUCATION, StudentServicePath } from "utils/constants";
import { studentRequests } from "api/studentApi";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Datagrid,
  Form,
  FunctionField,
  SimpleShowLayout,
  TextField,
  ReferenceInput,
  AutocompleteInput,
} from "react-admin";
import { Box, Card, CardContent, Chip, IconButton, Typography, useMediaQuery } from "@mui/material";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { settings } from "app";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { administrationRequests } from "api/administrationApi";
import { tenants } from "utils/tenants";
import { SectionTitle } from "features/SectionTitle";

const StudentRecordDisciplines = ({ studentName, educationId }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const { id } = useParams();
  const [departmentId, setDepartmentId] = useState(null);
  const [studentDisciplines, setStudentDisciplines] = useState(null);

  useEffect(() => {
    const fetchStudentRecord = async () => {
      if (!id) return;
      try {
        const url = departmentId
          ? studentRequests.getStudentRecordDisciplineByDepartmentId(id, departmentId)
          : studentRequests.getStudentRecordDisciplines(id);
        const { data } = await dataProvider.customRequest(url, null, "GET");
        setStudentDisciplines(data);
      } catch (err) {
        console.error(err);
        setStudentDisciplines({ semesters: [] });
      }
    };
    fetchStudentRecord();
  }, [id, departmentId]);

  const onDepartmentChange = value => {
    setDepartmentId(value);
  };

  const handleNavigate = rec => {
    navigate(`/${StudentServicePath}${RECORDS}/${STUDENT_EDUCATION}/${id}/${DISCIPLINES}/${rec.disciplineId}`, {
      state: {
        studentName,
        educationId,
        disciplineName: rec?.disciplineName,
      },
    });
  };

  if (!studentDisciplines) return null;

  return (
    <>
      <SectionTitle
        title="Учебни дисциплини по семестри"
        textAlign="center"
        sx={{ m: 1 }}
      />
      {settings.tenant === tenants.MU ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Form>
            <ReferenceInput
              source="departmentIds"
              reference={administrationRequests.getDepartmentsSelect()}
              filter={{ filterByUser: true }}
            >
              <AutocompleteInput
                label="Катедра"
                optionText="name"
                style={{ width: 300 }}
                onChange={onDepartmentChange}
              />
            </ReferenceInput>
          </Form>
        </Box>
      ) : null}
      {studentDisciplines?.semesters?.map((sem, index) => (
        <SimpleShowLayout
          record={studentDisciplines}
          key={`semester-${sem.semester}-${index}`}
        >
          <Card sx={{ mb: 2 }}>
            <CardContent>
              <Typography
                color="primary.dark"
                variant="h6"
                fontWeight="bold"
              >
                Семестър {sem.semester}
              </Typography>
              <Datagrid
                resource="student-disciplines"
                data={sem.disciplines}
                rowClick={false}
                bulkActionButtons={false}
                sx={[settings.style.detailsDatagrid, { "& .column-disciplineName": { width: "60%" } }]}
              >
                <TextField
                  source="disciplineName"
                  label="Дисциплини"
                />
                <FunctionField
                  label="Практически изпит"
                  render={rec =>
                    rec.hasPracticalExam ? (
                      <Chip
                        label="Да"
                        color="success"
                        size="small"
                      />
                    ) : (
                      <Chip
                        label="Не"
                        variant="outlined"
                        size="small"
                      />
                    )
                  }
                />
                <FunctionField
                  render={rec => {
                    return (
                      <SecuredComponent permission={permissions.canPreviewStudentRecords}>
                        {isMobile ? (
                          <IconButton
                            color="primary"
                            onClick={() => handleNavigate(rec)}
                          >
                            <ReceiptLongIcon />
                          </IconButton>
                        ) : (
                          <Button
                            label="Частичен картон"
                            variant="contained"
                            startIcon={<ReceiptLongIcon />}
                            onClick={() => handleNavigate(rec)}
                          />
                        )}
                      </SecuredComponent>
                    );
                  }}
                />
              </Datagrid>
            </CardContent>
          </Card>
        </SimpleShowLayout>
      ))}
    </>
  );
};

export default StudentRecordDisciplines;
